/**
 * Single source of truth for responsive breakpoints.
 *
 * Tiers:
 *  - phone   : viewport < 640px
 *  - tablet  : 640px <= viewport < 1024px
 *  - desktop : viewport >= 1024px
 *
 * The numeric values are exported so JS-driven layout decisions and CSS
 * authors can stay in sync; the `MQ` map gives ready-to-use matchMedia
 * strings. Keep tokens.css comments aligned with the values here.
 */

export const BREAKPOINTS = {
  phone: 640,
  tablet: 1024,
} as const;

export type BreakpointName = "phone" | "tablet" | "desktop";

export const MQ = {
  phone: `(max-width: ${BREAKPOINTS.phone - 1}px)`,
  tablet: `(min-width: ${BREAKPOINTS.phone}px) and (max-width: ${BREAKPOINTS.tablet - 1}px)`,
  desktop: `(min-width: ${BREAKPOINTS.tablet}px)`,
  // Convenience: anything below desktop, i.e. phone or tablet.
  notDesktop: `(max-width: ${BREAKPOINTS.tablet - 1}px)`,
  // Touch-capable input as the primary pointing device. Used to hide
  // keyboard-only affordances on phones and tablets even when an attached
  // keyboard could technically reach them.
  touch: "(pointer: coarse)",
} as const;
